import React, { memo } from 'react';
import moment from 'moment';

import { SEGMENTS } from '@model';

const FootNote = ({ sequence = null, children }) => (
  <div className="source-text">
    {sequence > 0 && <sup>{sequence}</sup>}
    {children}
  </div>
);

const buildNotes = (notes) =>
  notes.map((note, i) => (
    <FootNote sequence={i + 1} key={i}>
      {note}
    </FootNote>
  ));

const isFieldHidden = (table, value) => {
  const field = table.find((f) => f?.info?.value === value);

  return field?.info.hideFlag;
};

const getCompanyOverviewNotes = ({
  buyerName,
  buyerFactivaReportingDate,
  targetName,
  targetFactivaReportingDate,
  table = [],
}) => {
  const notes = [];

  if (!isFieldHidden(table, 'Financial Statement')) {
    notes.push(
      'Employee Headcount data reflects data pulled from most recent financial statements reported to the SEC.',
    );
  }

  if (!isFieldHidden(table, 'Dun & Bradstreet')) {
    notes.push(
      `Employee Headcount data reflects data pulled from Dun & Bradstreet
      database, 
      ${
        buyerName && buyerFactivaReportingDate
          ? `${buyerName} updated on ${moment(buyerFactivaReportingDate).format(
              'MM/DD/YYYY',
            )}, `
          : ''
      }
      ${
        targetName && targetFactivaReportingDate
          ? `${targetName} updated on ${moment(
              targetFactivaReportingDate,
            ).format('MM/DD/YYYY')}, `
          : ''
      }
      based on most recent update to Headquarter headcount.`,
    );
  }

  if (!isFieldHidden(table, 'LE Subsidiaries')) {
    notes.push(
      'Subsidiary count does not include parent company(headquarters).',
    );
  }

  return notes;
};

const NOTES = (additionalData) => ({
  [SEGMENTS.companyoverview]: (
    <>{buildNotes(getCompanyOverviewNotes(additionalData))}</>
  ),
  [SEGMENTS.financials]: (
    <FootNote>
      Source: Financial information reflects data from company websites and
      company financial statements reported to the SEC.
    </FootNote>
  ),
  [SEGMENTS.operationalfootprint]: (
    <FootNote sequence={1}>
      Subsidiary count does not include parent company (headquarters)
    </FootNote>
  ),
});

function SummaryFooter({ selectedMenu, data }) {
  //TODO: ReFactor This Comp
  return (
    <div>
      {
        NOTES(
          selectedMenu === SEGMENTS.companyoverview
            ? {
                buyerFactivaReportingDate: data.buyerFactivaReportingDate,
                targetFactivaReportingDate: data.targetFactivaReportingDate,
                buyerName: data.detail?.cn[0].companyName,
                targetName: data.detail?.cn[1].companyName,
                table: data?.table,
              }
            : {
                table: data?.table,
              },
        )[selectedMenu]
      }
    </div>
  );
}

export default memo(SummaryFooter);
